"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TagState = exports.TagFetchState = exports.PAGE_SIZE = void 0;
var tslib_1 = require("tslib");
var mobx_1 = require("mobx");
var i18n_1 = require("../i18n");
var tag_map_state_1 = require("../modules/tag.map/tag.map.state");
var services_1 = require("../services");
var mobx_2 = require("../state/mobx");
var page_state_1 = require("../state/page.state");
var tag_sort_state_1 = require("../state/tag.sort.state");
var store_1 = require("../store");
var tag_edit_state_1 = require("./tag.edit.state");
var tag_export_state_1 = require("./tag.export.state");
exports.PAGE_SIZE = 22;
var TagFetchState;
(function (TagFetchState) {
    TagFetchState["UNKNOWN"] = "UNKNOWN";
    TagFetchState["HAS_TAGS"] = "HAS_TAGS";
    TagFetchState["NO_TAGS"] = "NO_TAGS";
    TagFetchState["EMPTY_TAGS"] = "EMPTY_TAGS";
})(TagFetchState || (exports.TagFetchState = TagFetchState = {}));
var TagState = /** @class */ (function (_super) {
    tslib_1.__extends(TagState, _super);
    function TagState() {
        var _this = _super.call(this) || this;
        _this.loadMoreCount = tag_sort_state_1.MAX_TAG_SHOWN;
        _this.loaded = false;
        _this.map = new tag_map_state_1.TagMapState(_this);
        _this.edit = new tag_edit_state_1.TagEditState(i18n_1.T.TAG_NAME);
        _this.tagExport = new tag_export_state_1.TagExportState();
        _this.reaction(function (_) { return services_1.Services.Department.current; }, function () { return page_state_1.CurrentState.clearSelected(); });
        return _this;
    }
    TagState.prototype.destroy = function () {
        _super.prototype.destroy.call(this);
        this.map.destroy();
    };
    Object.defineProperty(TagState.prototype, "tags", {
        get: function () {
            var tags = [];
            this.loaded = false;
            for (var _i = 0, _a = store_1.AppStore.Tag.all; _i < _a.length; _i++) {
                var tag = _a[_i];
                var tagSummary = store_1.AppStore.TagSummary.get(tag.objectId);
                if (tagSummary !== undefined) {
                    this.loaded = true;
                }
                if (!tagSummary || tagSummary.revisions.length === 0) {
                    continue;
                }
                tags.push(tag);
            }
            if (store_1.AppStore.Tag.all.length === 0 && store_1.AppStore.Tag.fetched) {
                this.loaded = true;
            }
            return tags;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TagState.prototype, "filteredTags", {
        get: function () {
            if (store_1.AppStore.Tag.all == null) {
                return [];
            }
            var tags = [];
            var shouldCheckFilter = services_1.Services.Search.filterState.hasFilter();
            for (var _i = 0, _a = store_1.AppStore.Tag.all; _i < _a.length; _i++) {
                var tag = _a[_i];
                if (shouldCheckFilter) {
                    var filtered = services_1.Services.Search.includesTag(tag) || page_state_1.CurrentState.Tag.isTagSelected(tag.objectId);
                    if (!filtered) {
                        continue;
                    }
                }
                var tagSummary = store_1.AppStore.TagSummary.get(tag.objectId);
                if (tagSummary == null || tagSummary.revisions.length === 0) {
                    continue;
                }
                tags.push(tag);
            }
            return tag_sort_state_1.TagSortState.sortTags(tags);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TagState.prototype, "fetchState", {
        get: function () {
            // Fetching tags and tag summaries
            var tags = this.tags;
            if (!store_1.AppStore.Tag.fetched || !this.loaded) {
                return TagFetchState.UNKNOWN;
            }
            if (store_1.AppStore.Tag.all.length > 0 && this.tags.length === 0 && tags != null) {
                return TagFetchState.EMPTY_TAGS;
            }
            if (this.tags.length > 0) {
                return TagFetchState.HAS_TAGS;
            }
            return TagFetchState.NO_TAGS;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TagState.prototype, "visibleTags", {
        get: function () {
            var tags = this.filteredTags.length < this.loadMoreCount
                ? this.filteredTags
                : this.filteredTags.slice(0, this.loadMoreCount);
            page_state_1.CurrentState.Tag.setVisibleTagListObjectIDs(tags.map(function (tag) { return tag.objectId; }));
            return tags;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TagState.prototype, "hasMore", {
        get: function () {
            return this.filteredTags.length > this.loadMoreCount;
        },
        enumerable: false,
        configurable: true
    });
    TagState.prototype.loadMore = function () {
        this.loadMoreCount += tag_sort_state_1.MAX_TAG_SHOWN;
        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.BigMap, 'Tag:LoadMore', String(this.loadMoreCount), 1);
    };
    TagState.prototype.expandTag = function (tag) {
        page_state_1.CurrentState.setExpandedTagId(tag.objectId);
        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.BigMap, 'Tag:Expand', tag.objectId, 1);
    };
    TagState.prototype.collapseTag = function (tag) {
        page_state_1.CurrentState.setExpandedTagId(null);
        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.BigMap, 'Tag:Collapse', tag.objectId, 1);
    };
    Object.defineProperty(TagState.prototype, "allSelected", {
        get: function () {
            for (var _i = 0, _a = this.filteredTags; _i < _a.length; _i++) {
                var tag = _a[_i];
                var tagSummary = store_1.AppStore.TagSummary.get(tag.objectId);
                if (tagSummary == null || tagSummary.revisions.length !== page_state_1.CurrentState.Tag.collectionsSelectedSize(tag.objectId)) {
                    return false;
                }
            }
            return true;
        },
        enumerable: false,
        configurable: true
    });
    TagState.prototype.inspectHovered = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var hoverId, canChange;
            return tslib_1.__generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        hoverId = page_state_1.CurrentState.hoverId;
                        return [4 /*yield*/, this.map.checkChangeCollection(hoverId)];
                    case 1:
                        canChange = _a.sent();
                        if (canChange) {
                            page_state_1.CurrentState.setInspectedCollection(hoverId);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    tslib_1.__decorate([
        mobx_1.observable
    ], TagState.prototype, "loadMoreCount", void 0);
    tslib_1.__decorate([
        mobx_1.computed
    ], TagState.prototype, "tags", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], TagState.prototype, "filteredTags", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], TagState.prototype, "fetchState", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], TagState.prototype, "visibleTags", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], TagState.prototype, "hasMore", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], TagState.prototype, "loadMore", null);
    tslib_1.__decorate([
        mobx_1.action
    ], TagState.prototype, "expandTag", null);
    tslib_1.__decorate([
        mobx_1.action
    ], TagState.prototype, "collapseTag", null);
    tslib_1.__decorate([
        mobx_1.computed
    ], TagState.prototype, "allSelected", null);
    tslib_1.__decorate([
        mobx_1.action.bound
    ], TagState.prototype, "inspectHovered", null);
    return TagState;
}(mobx_2.MobxState));
exports.TagState = TagState;
//# sourceMappingURL=tag.state.js.map